import { chakra } from "@chakra-ui/react";
import { Box, Text } from "@chakra-ui/react";
import { WarningIcon } from "@chakra-ui/icons";

export const EmailVerifyWrapper = chakra(Box, {
  baseStyle: {
    padding: "44px 26px",
    h: "388px",
    w: "550px",
    bg: "#FFFFFF",
    shadow: "0px 3px 11px 0px #1819B40F",
    display: "flex",
    flexDirection: "column",
    borderRadius: "20px",
    alignItems: "center",
    textAlign: "center",
  },
});

export const EmailVerifyIconCircle = chakra(Box, {
  baseStyle: {
    width: "100px",
    height: "100px",
    borderRadius: "full",
    backgroundColor: "#FEF3C7",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "24px",
  },
});

export const EmailVerifyIcon = chakra(WarningIcon, {
  baseStyle: {
    color: "#F59E0B",
    fontSize: "24px",
    width: "60px",
    height: "60px",
  },
});

export const EmailVerifyHeading = chakra(Text, {
  baseStyle: {
    fontFamily: "Poppins",
    fontWeight: 600,
    fontSize: "18px",
    color: "#1F2937",
    marginBottom: "12px",
  },
});

export const EmailVerifyText = chakra(Text, {
  baseStyle: {
    fontFamily: "Poppins",
    fontWeight: 400,
    fontSize: "14px",
    color: "#798692",
  },
});
